class SortingComponent {
	constructor(options) {
		this.dropdown = document.querySelectorAll('.sortingDropdown');
		this.options = options;

		this._init();
	}

	_init() {
		if (this.dropdown) {
			this.dropdown.forEach((dropdown) => {
				dropdown.addEventListener('click', (ev) => {
					const clicked = ev.target.closest('.select-item');

					if (!clicked || clicked.classList.contains('selected')) {
						return;
					}

					const selectedElements = this._getSelectedSortingElement();

					selectedElements.forEach((selectedElement) => {
						selectedElement.classList.remove('selected');
					});

					const dropdownSelectedTextEl = document.querySelector('.sortingDropdown .dropdown-toggle .text');

					if (dropdownSelectedTextEl) {
						dropdownSelectedTextEl.textContent = clicked.textContent;
					}

					const mobileOrderSelectedTextEl = document.querySelector('.mobileOrder .short-name');

					if (mobileOrderSelectedTextEl) {
						mobileOrderSelectedTextEl.textContent = clicked.textContent;
					}

					const selectedSorting = clicked.dataset.value;
		
					clicked.classList.add('selected');
		
					this.options.onSelect(selectedSorting);
				});
			});
		}
	}

	_getSelectedSortingElement() {
		const selectedElements = [];

		this.dropdown.forEach((dropdown) => {
		  const selected = dropdown.querySelectorAll('.dropdown-menu .select-item.selected');

		  selectedElements.push(...selected);
		});

		return selectedElements;
	}
}

export default SortingComponent;